import { fetchWrapper } from '../helpers';

export const vendorService = {
  getProfileByName
};

const baseUrlAPI = `${process.env.API_BASE_URL}`;

// API
function getProfileByName(name) {
  return fetchWrapper.get(`${baseUrlAPI}/form/vendor-profile/${name}`);
}